(function(){
  var root=document.currentScript.closest('.lst-scope') || document;

  // Deal countdown(s)
  root.querySelectorAll('[data-lst-timer]').forEach(function(el){
    var mins=parseInt(el.getAttribute('data-lst-timer'),10)||6;
    var t=mins*60;
    function pad(n){return n<10?'0'+n:n;}
    function tick(){if(t<=0){t=mins*60;}el.textContent=pad(Math.floor(t/60))+':'+pad(t%60);t--;}
    tick();setInterval(tick,1000);
  });

  // Carousel arrows
  root.querySelectorAll('.lst-ptc-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var track=document.getElementById(btn.getAttribute('data-target'));
      if(!track)return;
      var card=track.querySelector('.lst-ptc-card');
      var step=card?card.offsetWidth+16:316;
      track.scrollBy({left:step*parseInt(btn.dataset.dir,10),behavior:'smooth'});
    });
  });

  // Sticky reveal: 1 = show immediately on load, 2+ = reveal after that reason
  var sticky=root.querySelector('#lst-sticky');
  if(sticky){
    var after=parseInt(sticky.getAttribute('data-reveal'),10)||4;
    if(after<=1){
      sticky.classList.add('is-visible');
    } else {
      var reasons=root.querySelectorAll('.lst-reason');
      var trigger=reasons[Math.min(after,reasons.length)-1];
      if(trigger){
        var check=function(){
          if(trigger.getBoundingClientRect().bottom < window.innerHeight*0.5){
            sticky.classList.add('is-visible');
            window.removeEventListener('scroll',check);
          }
        };
        window.addEventListener('scroll',check,{passive:true});
        check();
      } else { sticky.classList.add('is-visible'); }
    }
  }
})();
